/**
 * Returns true if the provided timestamp is for a date in the past.
 * @param timestamp
 * @returns boolean
 */
export const isDateInThePast = (timestamp: string) => {
    return new Date(timestamp) <= new Date();
};
